import axios from 'axios'

import { EVERSIGN_BUSINESS_ID, EVERSIGN_ACCESS_KEY } from '../config'

const eversign = axios.create({
  baseURL: 'https://api.eversign.com'
})

//all calls will have '/api' and most '/document' attached to the base URL: "/api/document"
const URL_PREFIX = '/api'
const ID = '?access_key=' + EVERSIGN_ACCESS_KEY + '&business_id=' + EVERSIGN_BUSINESS_ID

export const createDocument = (param) => {
  return eversign.post(URL_PREFIX + '/document' + ID, param)
}

export const getAllDocuments = () => {
  return eversign.get(URL_PREFIX + '/document' + ID + '&type=all')
}

export const getDocument = (hash) => {
  return eversign.get(URL_PREFIX + '/document' + ID + '&document_hash=' + hash)
}

export const getDocumentPDF = (hash) => {
  //only gets URL, can get more info if needed
  return eversign.get(URL_PREFIX + '/download_final_document' + ID + '&document_hash=' + hash + '&url_only=1')
}

export const uploadFile = (file) => {
  const formData = new FormData()
  formData.append('upload', file)
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }

  return eversign.post(URL_PREFIX + '/file' + ID, formData, config)
}
